const orderBatchErrorResponseToOrderBatchErrorObject = (response) => {
    return {
        orderId: response.order_id,
        errorMessage: response.error_message
    };
};

export { orderBatchErrorResponseToOrderBatchErrorObject };